import './generateCard.css';
import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { GET_APPLICATION_LIST, GET_USER_DETAILS, SEND_CARD_FOR_PRINTING } from '../../../common/URLs';
import { useNavigate } from "react-router-dom";
import { PrintWrapper } from './printWrapper';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { Button, Box, Card, CardContent, Grid } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import Link from "@mui/material/Link";
import { PROD } from '../../../common/constants';
import { lastFiveDigitsComparator } from '../../../common/commonFunction';
import { useTranslation } from 'react-i18next';
import { SendIcon } from '../../../common/icons';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { loaderService } from '../../../common/custom-loader/loader-service';
import { toast } from 'react-toastify';
import apiClient from '../../../axios';

const GenerateCard = () => {
  const { t } = useTranslation();
  const [stakeHolders, setStakeHolders] = useState();
  const [userId, setUserId] = useState();
  const [urn, setUrn] = useState("");
  const [emailId, setEmailId] = useState();
  const [userDetails, setUserDetails] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [printCardResponse, setPrintCardResponse] = useState();

  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [isApiCalled, setIsApiCalled] = useState(false);

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      const decoded = jwt(getLocalStorageItem('id_token'));
      setUrn(decoded.extension_URN)
      const email = decoded.emails?.[0];
      setEmailId(email);
    }
  }, [getLocalStorageItem('id_token')]);

  useEffect(() => {
    if (emailId) {
      getUserDetails();
    }
  }, [emailId]);

  function getUserDetails() {
    loaderService.showLoader();
    apiClient
      .post(GET_USER_DETAILS,
        {
          "emailAddress": emailId
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setUserDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }
  useEffect(() => {
    if (userDetails) {
      const userid = userDetails?.user?.id;
      setUserId(userid);
    }
  }, [userDetails]);

  const navigate = useNavigate();

  useEffect(() => {
    if (userId) {
      getAllApprovedStakeholders();
    }
  }, [userId]);

  const onView = (params) => {
    const userData = {
      "urnSelected": params?.row?.urn,
      "userId": userId
    }
    navigate("/registrationHome/cardGeneration/onView", { state: { data: userData } });
  }


  function getAllApprovedStakeholders() {
    loaderService.showLoader();
    apiClient
      .post(GET_APPLICATION_LIST,
        {
          "userID": userId,
          "status": "Approved"
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeHolders(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }
  const onSendForPrintingClick = (e) => {
    e.preventDefault();
    if (selectedRows.length == 0) {
      toast.error("Please select stakeholders to print ID Card");
    }
    else {
      handleConfirmLogModalOpen();
    }
  }

  // const onConfirmSubmit = () => {
  //   handleConfirmLogModalClose();
  //   sendForPrinting();
  // }

 
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await sendForPrinting();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogConfirmModalOpen(false);
            setIsApiCalled(false);
        }
    };

  function sendForPrinting() {
    loaderService.showLoader()
    apiClient
      .post(SEND_CARD_FOR_PRINTING,
        {
          "urnList": selectedRows,
          "categoryName": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setPrintCardResponse(response.data);
        setSelectedRows([])
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  useEffect(() => {
    if (printCardResponse) {
      if (printCardResponse.isSuccess === true) {
        toast.success("Stakeholder ID sent for printing successfully.");
      } else {
        toast.error("An error occured while sending for printing!");
      }
    }

  }, [printCardResponse]);


  const columns = [
    {
      field: 'name', headerName: t('preReg.name'), width: 220,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
          {params.value}
        </div>
      ),
      valueGetter: (params) => params.value
    },
    {
      field: 'urn', headerName: 'URN', width: 220, sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
      renderCell: (params) => { return (<Link to={params} onClick={() => { onView(params) }}>{params.value}</Link>) }
    },
    { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 220 },
    {
      field: 'Action', width: 150,
      renderCell: (cellValues) => {
        return (
          <PrintWrapper urn={cellValues?.row?.urn} />
        );
      }
    },
  ];

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} lg={12}>
          {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG59</p>}
          <Card>
            <CardContent>
              <Box sx={{
                height: 500, width: '100%',
                '& .MuiDataGrid-cell--editable': {
                  bgcolor: (theme) =>
                    theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                },
              }}>
                {
                  stakeHolders?.scrutinyWorkFlowStepDetails &&
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
                    }}
                    getRowHeight={() => 'auto'}
                    rows={stakeHolders?.scrutinyWorkFlowStepDetails}
                    columns={columns}
                    pageSize={10}
                    checkboxSelection
                    onSelectionModelChange={(newSelection) => {
                      setSelectedRows(newSelection.map(row => {
                        let urn = ""
                        stakeHolders?.scrutinyWorkFlowStepDetails.forEach(item => {
                          if (row == item.id) {
                            urn = item.urn;
                          }
                        })
                        return urn;
                      }));
                    }}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />
                }

              </Box>
            </CardContent>
          </Card>
          <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
            <Button endIcon={<SendIcon />} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onSendForPrintingClick(e)}>Send For Printing</Button>
          </Box>
        </Grid>
      </Grid>
      <ConfirmationPopover onOpen={logConfirmModalOpen} action="Submit" onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} />
    </>
  );
}
export default GenerateCard;